<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="align-center">
        <v-flex xs12 sm4 md4>
          <h3>Referral</h3>
          <p>Refer other users</p>
        </v-flex>
        <v-flex xs12 sm8 md8>
          <v-card>
            <v-card-title class="pa-0">
              Your Referral Code
              <v-spacer></v-spacer>
              <v-btn small icon @click="update = !update" title="Change your referral code" color="warning" v-show="referralCode && referralCode.id">
                <v-icon>{{ icons.edit }}</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <h1>
                <span class="text-uppercase">{{ referralCode ? referralCode.code : '' }}</span>
              </h1>
              <p>Give this code to other user. They must enter it just after signing up.</p>
              <p>
                You have referred <code>{{ referrals_count }}</code>
                <span v-if="referrals_count == 1">user</span>
                <span v-else>users</span>
              </p>
              <hr :class="'transparent'" v-show="canEnterCode">
              <enter-referral-code v-if="user.referrals_count == 0 && daysFrom < 8" :errors="errors"></enter-referral-code>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <mk-dialog v-model="update">
        <template #title>Update your Referral Code</template>
        <v-card>
          <v-card-text>
            <update-referral-code :referralCode="referralCode" @saved="update = false" :errors="errors"></update-referral-code>
          </v-card-text>
        </v-card>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  const EnterReferralCode = async () => await import(/* webpackChunkName: "user-profile" */ '@/Components/Profile/EnterReferralCode')
  const UpdateReferralCode = async () => await import(/* webpackChunkName: "user-profile" */ '@/Components/Referral/edit')
  const MkDialog = async () => await import(/* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')

  export default {
    name: 'ReferralCode',
    props: [
      'user',
      'errors',
    ],
    components: {
      MkDialog,
      EnterReferralCode,
      UpdateReferralCode,
    },
    data () {
      return {
        saving: false,
        update: false
      }
    },
    methods: {
      getCode () {
        this.$inertia.get('/user/' + this.user.id + '/referral-code', {}, {
          preserveScroll: true,
          preserveState: true,
        })
        // .then(res => {
        //   // let code = res.data.referral_code
        //   // this.referralCode = code
        // })
        // .catch(err => {
        //   //
        // })
        // .finally(() => {
        //   this.$inertia.reload()
        // })
      },
    },
    mounted () {
      this.$nextTick(() => {
        if (!this.referralCode) {
          this.getCode()
        }
      })
    },
    computed: {
      referrals_count () {
        if (!this.referralCode) {
          return 0
        }
        return this.referralCode.referrals_count
      },
      referralCode () {
        return this.user.referral_code
      },
      daysFrom () {
        return this.user.days_from_sign_up
      },
      canEnterCode () {
        return this.user.referrals_count == 0 && this.daysFrom < 8
      }
    }
  }
</script>
